var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('makuang-medical-label-record',{attrs:{"consultation":_vm.consultationPrescription,"status":_vm.printStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }